import { DataBean } from "../DataBean";

export class QualityInformationILES extends DataBean {

  public async getQualityInformationILESCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInformationILESCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInformationILESRender( page: number, rows: number, properties: any, fromDate: any, uptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInformationILESRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, fromDate, uptoDate]
    );
  }

  public async deleteQualityInformationILES(idqualityinformationiles: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInformationILES_Number", [idqualityinformationiles]);
  }

  public async updateQualityInformationILES(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInformationILES_updateQualityInformationILES_com.orange.finance.processcontract.bean.QualityInformationILES",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInformationILES",
        },
      ]
    );
  }
}
